import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "@/components/slick-slider/slick-custom.css";
import React from "react";
import Slider from "react-slick";

import { classNames } from "@/helpers/classNames";

import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/24/outline";

function CustomNextArrow({ className, style, onClick, ...other }) {
  return (
    <button type="button" className={className} style={style} onClick={onClick}>
      <ChevronRightIcon
        {...other}
        className="rounded-lg text-text-primary hover:bg-background-secondary/10 hover:text-text-secondary"
        style={{
          width: "100%",
          height: "100%",
          margin: "auto",
        }}
      />
    </button>
  );
}

function CustomPrevArrow({ className, style, onClick, ...other }) {
  return (
    <button type="button" className={className} style={style} onClick={onClick}>
      <ChevronLeftIcon
        {...other}
        className="rounded-lg text-text-primary hover:bg-background-secondary/10 hover:text-text-secondary"
        style={{
          width: "100%",
          height: "100%",
          margin: "auto",
        }}
      />
    </button>
  );
}

function SlickSlider({
  className,
  dots = false,
  forwardRef = undefined,
  ...other
}) {
  const settings = {
    arrows: false,
    dots: dots,
    infinite: true,
    speed: 500,
    autoplaySpeed: 10000,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    customPaging: () => (
      <div className="aspect-[1/1] w-full cursor-pointer rounded-full bg-background-primary hover:bg-background-secondary" />
    ),
  };
  return (
    <Slider
      {...settings}
      {...other}
      className={classNames(dots && "mb-12", className)}
      ref={forwardRef}
    />
  );
}

export default SlickSlider;
